import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import * as aa from "../../generated/UserAPIAgent";
import { URL_PATHS } from "../../routes";

interface PrivateRouteProps extends RouteProps {
    user: aa.User | null;
    children: JSX.Element;
}

const PrivateRoute = (props: PrivateRouteProps) => {
    const { children, user, ...rest } = props;
    return (
        <Route
            {...rest}
            render={({ location }) =>
                user ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: URL_PATHS.login(),
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
